import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { CustomPhonePipe } from 'src/app/shared/pipes/custom-data-filters.pipe';
import { ApiHandlerService } from 'src/app/shared/services/api-handler.service';
import { CmnFunctionService } from 'src/app/shared/services/cmn-function.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Component({
  selector: 'app-help-and-support',
  templateUrl: './help-and-support.component.html',
  styleUrls: ['./help-and-support.component.scss']
})
export class HelpAndSupportComponent implements OnInit {
  helpForm: FormGroup;
  public isLoadingData: boolean = false;
  public submitted: boolean = false;
  public inquryTypes: any;
  private readonly emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  constructor(
    public formBuilder: FormBuilder,
    public _service: ApiHandlerService,
    public toaster: ToasterService,
    public customPhone: CustomPhonePipe,
    private _location: Location,
    public cmnFunction: CmnFunctionService,

  ) {
    // To get Inquiry Types
    this.getInquiryTypes();

    // this.helpForm = this.formBuilder.group({
    //   name: ['', Validators.required, this.noWhitespaceValidator()],
    //   email: ['', [Validators.required, Validators.email]],
    //   mobileNumber: ['', Validators.required],
    //   type: ['', Validators.required],
    //   message: ['', Validators.required, this.noWhitespaceValidator()]
    // })
  }

  get f() { return this.helpForm.controls; }



  ngOnInit(): void {
    this.helpForm = this.formBuilder.group({
      name: ['', [Validators.required, this.noWhitespaceValidator()]],
      email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      mobileNumber: ['', [Validators.required, Validators.minLength(14)]], 
      type: ['', [Validators.required]],
      message: ['', [Validators.required, this.noWhitespaceValidator()]]
    });
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && typeof control.value === 'string' && control.value.trim().length === 0) {
        return { 'whitespace': true };
      }
      return null;
    };
  }


  submitHelp() {
    this.submitted = true;
    this.helpForm.markAllAsTouched();

    if (this.helpForm.invalid) return;
    this.isLoadingData = true;

    //pass data to API here..
    const apiParam = {
      name: this.helpForm.value.name,
      email: this.helpForm.value.email,
      phoneNo: this.customPhone.transform(this.helpForm.value.mobileNumber, ''),
      type: this.helpForm.value.type,
      message: this.helpForm.value.message
    }

    //apiPost function for post data to Db...
    this._service.apiPost(this._service.marketingBaseUrl + 'add-query', apiParam).subscribe({
      next: result => {
        if (result['status']) {
          //here we will store the data in the stroage....
          this.isLoadingData = false;

          //reset data...
          this.submitted = false;
          this.helpForm.reset()
          this.helpForm.controls['type'].setValue('');
          this.toaster.Success(result.message);
        } else {
          this.isLoadingData = false;
          this.toaster.Error(result.message);
        }
      }, error: err => {
        this.isLoadingData = false;
        this.toaster.Error(err);
      }
    });
  }
  getInquiryTypes() {
    this._service.apiGet(this._service.marketingBaseUrl + 'get-types').subscribe({
      next: result => {
        if (result.status) {
          this.inquryTypes = result.data.types;
        }
      }, error: err => {
        //  this.toaster.Error(err.mesage);
      }
    });
  }
  goBack() {
    this._location.back();
  }

}
